import { render } from "./NotesAndWarningsModal.vue?vue&type=template&id=2caa75bc"
import script from "./NotesAndWarningsModal.vue?vue&type=script&lang=js"
export * from "./NotesAndWarningsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__